import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { KnowledgeQuestion } from "../questions";

const SHORT_OPTION_LENGTH = 40;

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    question: { type: Object as PropType<KnowledgeQuestion>, required: true },
    index: { type: Number, required: true },
    modelValue: { type: Number as PropType<number | null>, default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  computed: {
    isShort(): boolean {
      return this.question.options.every(
        (option) => option.length < SHORT_OPTION_LENGTH
      );
    },
  },
});
